import convertToString from "./convertToString";
export default function write(storage, key, entity) {
    const value = convertToString(entity);
    storage.setItem(key, value);
}
